import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";

import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";
import { timestampColumn } from "../../../ui/utils/columns";

export default function ArtifactExpiredExportsView({ artifact }) {
	const { t } = useTranslation();

	return (
		<>
			<Header as="h3">{t("expiredExports", "Expired Exports")}</Header>

			<CollectionDataTable
				columns={[
					timestampColumn({ id: "created", Header: t("created", "Created") }),
					timestampColumn({ id: "deletedAt", Header: t("deleted", "Deleted") }),
				]}
				sortable={false}
				hoverRow={false}
				query={db.collection("exports").where("artifact.ref", "==", artifact.ref).where("deleted", "==", true)}
			/>
		</>
	);
}
